export const SET_CASH_DESK_SETTINGS_CART_SETTINGS = 'SET_CASH_DESK_SETTINGS_CART_SETTINGS'
export const UPDATE_CASH_DESK_SETTINGS_CART_SETTING = 'UPDATE_CASH_DESK_SETTINGS_CART_SETTING'
export const SET_CASH_DESK_CHANGE_SETTINGS = 'SET_CASH_DESK_CHANGE_SETTINGS'
export const UPDATE_CASH_DESK_CHANGE_SETTING = 'UPDATE_CASH_DESK_CHANGE_SETTING'
export const SET_CASH_DESK_SETTINGS_WAITER_SETTINGS = 'SET_CASH_DESK_SETTINGS_WAITER_SETTINGS'
export const SET_CASH_DESK_SETTINGS_PRINT_SETTINGS = 'SET_CASH_DESK_SETTINGS_PRINT_SETTINGS'
export const SET_CASH_DESK_SETTINGS_BEEPER_CONFIGS = 'SET_CASH_DESK_SETTINGS_BEEPER_CONFIGS'
